<template>
    <div class="filters pt-2">
        <div class="form-check ms-4">
            <input v-model="filters.status" id="checkbox-active" type="checkbox" class="form-check-input" value="active" />
            <label for="checkbox-active" class="form-check-label">Active</label>
        </div>
        <div class="form-check ms-4">
            <input v-model="filters.status" id="checkbox-inactive" type="checkbox" class="form-check-input" value="inactive" />
            <label for="checkbox-inactive" class="form-check-label">Inactive</label>
        </div>
        <div class="form-check ms-4">
            <input v-model="filters.status" id="checkbox-disabled" type="checkbox" class="form-check-input" value="disabled" />
            <label for="checkbox-disabled" class="form-check-label">Disabled</label>
        </div>
    </div>

    <table ref="table" class="table table-hover table-vcenter table-sm dataTable">
        <thead>
            <tr>
                <th>Name</th>
                <th>Short code</th>
                <th>Status</th>
                <th>Ad Slots</th>
                <th>URL Segmentations</th>
                <th></th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";

const props = defineProps({
    ajaxUrl: String,
});

const filters = ref({
    status: [
        'active',
        'inactive',
        'disabled',
    ],
});

const table = ref();

onMounted(() => {
    const dataTable = window.jQuery(table.value).on('preXhr.dt', (e, settings, data) => {
        data.filters = filters.value;
    }).DataTable({
        processing: true,
        serverSide: true,
        ajax: {
            url: props.ajaxUrl,
        },
        order: [0, "asc"],
        pageLength: 25,
        columns: [
            {
                data: 'name',
            },
            {
                data: 'short_name',
            },
            {
                data: 'status',
            },
            {
                data: 'inventories_count',
                searchable: false,
            },
            {
                data: 'url_segmentation_count',
                searchable: false,
            },
            {
                data: 'actions',
                orderable: false,
            },
        ],
    });

    watch(
        filters,
        () => dataTable.ajax.reload(null, false),
        {
            deep: true
        },
    );
});
</script>

<style scoped>
.filters {
    display: flex;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
}
</style>
